<template>
  <div>
    <div class="jumbotron jumbotron-fluid" v-for="(item, questionIndex) in quiz.questions"
    :key="questionIndex">
      <div class="container">
        <button type="button" class="btn btn-danger pull-right ml-4" @click="removeQuestion(questionIndex)">Supprimer la question &nbsp; <i class="fa fa-trash"></i></button>
        <h3><span class="headline">(Question {{questionIndex+1}}/{{quiz.questions.length}})  <b>{{item.question  | translategrader($i18n.locale)}}</b></span></h3>
        <hr>

        <div class="row">
          <div class="col-md-8 mb-4">
            <p>Titre de la question</p>
            <b-form-input
              :value="item.question | translategrader($i18n.locale)"
              placeholder="Titre de la question"
              @input="updateSimpleFieldQuestion($event, questionIndex, 'question')">
            </b-form-input>
          </div>

          <div class="col-md-4 mb-4">
            <p>Type de la question</p>
            <b-form-select
              v-model="item.questionType"
              :options="questionTypes"
              @input="updateQuestionType($event, questionIndex)">
            </b-form-select>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h3>Bonne pratique</h3>
              <p>(switch to <strong>
              <a @click="showHTMLEditor(questionIndex, false)" class="text-primary" v-if="viewHTML[questionIndex] === true">html view</a>
              <a @click="showHTMLEditor(questionIndex, true)" class="text-primary" v-else>visual view</a></strong>)</p>
          </div>
          <div class="col-12 question_editor" v-if="viewHTML[questionIndex] === true">
            <div :id="'toolbar'+questionIndex">
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-strike"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-direction" value="rtl"></button>
                <select class="ql-align"></select>
              </span>
              <span class="ql-formats">
                <button class="ql-link"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-clean"></button>
              </span>
            </div>
            <div
              label="La Bonne pratique"
              :value="item.resultat_texte | translategrader($i18n.locale)"
              @input="updateBonnePratiqueHTML($event, questionIndex)"
              :id="'question'+questionIndex"
            >
              <div v-html="$options.filters.translategrader(item.resultat_texte,$i18n.locale)"></div>
            </div>
          </div>
          <div class="col-12 question_editor" v-if="viewHTML[questionIndex] === false">
            <b-form-textarea
              id="textarea_bonne_pratique"
              :value="item.resultat_texte | translategrader($i18n.locale)"
              @input="updateSimpleFieldQuestion($event, questionIndex, 'resultat_texte')"
              placeholder="La bonne pratique"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <h3>Les réponses</h3>
          </div>
        </div>

        <div class="row mt-4 mb-0" v-for="(answer, answerIndex) in item.answers" :key="answerIndex">
          <div class="col-md-9">
            <p class="mb-0">Réponse</p>
            <b-form-input
            :value="answer.answer | translategrader($i18n.locale)"
            placeholder="Réponse à la question"
            @input="updateSimpleFieldAnswer($event, questionIndex, answerIndex, 'answer')">
            </b-form-input>
          </div>
          <div class="col-md-2">
            <p class="mb-0">Points</p>
            <div class="input-group number-controls">

              <div class="input-group-prepend minus">
                <span class="input-group-text" @click="decrAnswerPoints(questionIndex, answerIndex)">-</span>
              </div>

              <b-form-input v-model="answer.points" placeholder="4" @input="updateAnswerPoints($event, questionIndex, answerIndex)" type="number" class="form-control input-number"></b-form-input>

              <div class="input-group-append plus">
                <span class="input-group-text" @click="incrAnswerPoints(questionIndex, answerIndex)">+</span>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <p class="mb-0">&nbsp;</p>
            <button type="button" class="btn btn-danger pull-right ml-4" title="Supprimer la réponse" @click="removeAnswer({questionIndex, answerIndex})"><i class="fa fa-trash"></i></button>
          </div>
        </div>

        <div class="row mt-4" v-if="item.answers.length < 6">
          <div class="col">
            <button type="button" class="btn btn-success pull-left" title="Ajouter une réponse" @click="addAnswer(questionIndex)">Ajouter une réponse</button>
          </div>

        </div>

      </div>
    </div>
</div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex';
  import Vue from 'vue';
  import {
    ADD_ANSWER,
    UPDATE_QUESTION,
    REMOVE_QUESTION,
    REMOVE_ANSWER,
    UPDATE_ANSWER
  } from '@/store/quiz/mutations';

  export default {
    name: 'quiz-questions',

    data() {
      return {
        questionTypes: [
        {text: "Choix unique", value: "Radiogroup"},
        {text: "Selection multiple", value: "Checkbox"},
        {text: "Texte", value: "Text"}
        ],
        viewHTML: []
      }
    },

    mounted() {
        setTimeout( () => {
          for (var questionIndex in this.quiz.questions){
            var editorAnchor = '#question'+questionIndex;
            var toolbarAnchor = '#toolbar'+questionIndex;
            this.loadHTMLEditor(editorAnchor, toolbarAnchor);

            // init viewHTML boolean array
            this.viewHTML.push(true);
            // Vue.set(this.viewHTML, questionIndex, true);

          }
        }, 3000);
    },


    computed: {
      ...mapGetters('quiz', {
        quiz: 'newQuiz'
      }),

      myLocale : function() {
        return this.$i18n.locale;
      },

      descriptionHTML : function() {
        return this.$options.filters.translategrader(this.quiz.description,this.$i18n.locale);
      }
    },

    watch: {
      myLocale: function (newLocale, oldLocale) {

        this.viewHTML = []
        setTimeout( () => {
          for (var questionIndex in this.quiz.questions){
            var editorAnchor = '#question'+questionIndex;
            var toolbarAnchor = '#toolbar'+questionIndex;
            this.loadHTMLEditor(editorAnchor, toolbarAnchor);

            // init viewHTML boolean array
            this.viewHTML.push(true);
            // Vue.set(this.viewHTML, questionIndex, true);

          }
        }, 300);
      }
    },

    methods: {
      ...mapMutations('quiz', {
        addAnswer: ADD_ANSWER,
        updateQuestion: UPDATE_QUESTION,
        removeQuestion: REMOVE_QUESTION,
        removeAnswer: REMOVE_ANSWER,
        updateAnswer: UPDATE_ANSWER
      }),

      loadHTMLEditor(editorAnchor, toolbarAnchor) {
        setTimeout( () => {
          this.viewHTML.fill(true);
        }, 300); // Needed when change of lang
        var toolbarOptions = {
        container: toolbarAnchor}
        var options = {
              format: ['bold', 'italic', 'link', 'strike', 'script', 'underline'],
              theme: 'snow',
              modules: {
                toolbar: toolbarOptions
              }
            };

        setTimeout( () => {
          var quill = new Quill(editorAnchor, options);
        }, 100);

      },

      showHTMLEditor(questionIndex, value) {
        // See https://stackoverflow.com/a/43168821/2550237
        Vue.set(this.viewHTML, questionIndex, value)

        if (value) {
          this.loadHTMLEditor('#question'+questionIndex, '#toolbar'+questionIndex);
        }
      },

      updateSimpleFieldAnswer(value, questionIndex, answerIndex, targetKey) {
        // Saving objects in current language
        var tmpSurvey = Object.assign({}, this.quiz);
        var tmpTarget = tmpSurvey.questions[questionIndex]
            .answers[answerIndex];

        if (typeof this.$i18n.locale === "undefined") {
          tmpTarget[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        } else {

          if (tmpTarget[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpTarget[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            delete tmpTarget[targetKey];
            tmpTarget[targetKey] = {};
            tmpTarget[targetKey][this.$i18n.locale] = value;
          }
        }
        this.updateLocalStoreQuestion(tmpSurvey);

      },

      updateLocalStoreAnswer(dictObject, questionIndex, answerIndex) {
        this.updateAnswer({
          answer: dictObject
            .questions[questionIndex]
            .answers[answerIndex]
            .answer,
          points: dictObject
            .questions[questionIndex]
            .answers[answerIndex]
            .points,
          questionIndex,
          answerIndex,
        })
      },

      updateAnswerPoints(value, questionIndex, answerIndex) {
        this.updateAnswer({
          points: value,
          answer: this.quiz.
            questions[questionIndex]
            .answers[answerIndex]
            .answer,
          questionIndex,
          answerIndex,
        })
      },

      decrAnswerPoints(questionIndex, answerIndex) {
        var currentPoints = parseInt(this.quiz.questions[questionIndex].answers[answerIndex].points, 10);
        this.updateAnswerPoints((currentPoints-1).toString(10), questionIndex, answerIndex);
      },

      incrAnswerPoints(questionIndex, answerIndex) {
        var currentPoints = parseInt(this.quiz.questions[questionIndex].answers[answerIndex].points, 10);
        this.updateAnswerPoints((currentPoints+1).toString(10), questionIndex, answerIndex);
      },

      updateSimpleFieldQuestion(value, questionIndex, targetKey) {
        // Saving objects in current language
        var tmpSurvey = Object.assign({}, this.quiz);

        if (typeof this.$i18n.locale === "undefined") {
          tmpSurvey.questions[questionIndex][targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        } else {

          if(typeof tmpSurvey.questions[questionIndex][targetKey] === "undefined") { // Newly added questions
            tmpSurvey.questions[questionIndex][targetKey] = {};
            tmpSurvey.questions[questionIndex][targetKey][this.$i18n.locale] = value;
          }

          else if (tmpSurvey.questions[questionIndex][targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSurvey.questions[questionIndex][targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            delete tmpSurvey.questions[questionIndex][targetKey];
            tmpSurvey.questions[questionIndex][targetKey] = {};
            tmpSurvey.questions[questionIndex][targetKey][this.$i18n.locale] = value;
          }
        }
        this.updateLocalStoreQuestion(tmpSurvey);

      },

      updateLocalStoreQuestion(dictObject, questionIndex) {
        this.updateQuestion({
          question: dictObject.questions[questionIndex].question,
          questionType: dictObject.questions[questionIndex].questionType,
          points: dictObject.questions[questionIndex].points,
          resultat_texte: dictObject.questions[questionIndex].resultat_texte,
          questionIndex
        })
      },

      updateQuestionType(value, questionIndex) {
        this.updateQuestion({
          question: this.quiz.questions[questionIndex].question,
          questionType: value,
          points: this.quiz.questions[questionIndex].points,
          resultat_texte: this.quiz.questions[questionIndex].resultat_texte,
          questionIndex
        });
      },

      updateBonnePratiqueHTML(value, questionIndex) {
        this.updateSimpleFieldQuestion(value.target.innerHTML, questionIndex, 'resultat_texte');
      },

      updateQuestionPoints(value, questionIndex) {
        // deprecated : used to display the total number of points in admin
        // test if the input does not contain a valid number or the number is negative
        const points = parseInt(value);
        if (isNaN(points) || points < 0) return; // cancel triggering the mutation
        this.updateQuestion({
          question: this.quiz.questions[questionIndex].question,
          points,
          questionIndex
        });
      }
    }
  }
</script>

<style scoped>

a {
  cursor: pointer;
}

.jumbotron {
  padding-top: 30px;
  padding-bottom: 30px;
  border: 1px #ccc solid;
  border-radius: 5px;
}

.question_editor > div {
  background: #fff;
}

.ql-container {
  height: auto;
}


/* Numbers */
.number-controls {
  max-width: 130px;
  line-height: 1em;
}

.input-number {
  text-align: center;
}

.minus span{
  background-color: #D3C5C5;
}
.plus span{
  background-color: #C5D3C9;
}

.number-controls .input-group-prepend, .number-controls .input-group-append {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizQuestions.vue